import { II18nextPrefix } from 'types/components/components.interface';

import { Form, Formik, FormikConfig } from 'formik';
import { useTranslation } from 'react-i18next';
import { IFormikProps, IFormProps } from '../types';

import { Tab, TabsNavigation } from 'components/molecules';
import TopBar from 'components/organisms/top-bar/TopBar';
import { TopbarTabs } from 'components/templates';

import { useParamId } from 'hooks/useParamId';
import { IChannelVideoForm } from 'services/channel/types/query';
import { array, object } from 'yup';
import { settlementInfoContractValidation } from '../music-product-digital/MusicProductDigitalForm';
import ChannelVideoContractsFuture from './tabs/ChannelVideoContractsFuture';
import ChannelVideoContractsHistory from './tabs/ChannelVideoContractsHistory';
import ChannelVideoPlayer from './tabs/ChannelVideoPlayer';

import { useGetChannel } from 'services/channel';
import ChannelVideoData from './tabs/ChannelVideoData';

export const channelVideoInitialValues: IChannelVideoForm = {
  id: '',
  videoContracts: [],
  dateOfPublication: '',
  externalVideoId: '',
  videoImageLink: '',
  videoTitle: '',
  lastSyncDate: '',
  dislikesCount: 0,
  likesCount: 0,
  views: 0,
  isShorts: false,
};

const validator = object().shape({
  videoContracts: array().of(settlementInfoContractValidation),
});

export interface IChannelVideoFormProps
  extends FormikConfig<IChannelVideoForm>, IFormProps, II18nextPrefix {}

const ChannelVideoForm = ({
  i18nextPrefix,
  topbarContent,
  tittle,
  status,
  initialValues = channelVideoInitialValues,
  disableTabs,
  backPath,
  customBackItem,
  ...props
}: IChannelVideoFormProps) => {
  const channelId = useParamId('channel');
  const { t } = useTranslation();

  const channel = useGetChannel(channelId);

  return (
    <Formik
      {...props}
      validateOnChange
      validateOnBlur
      validateOnMount
      initialStatus={status}
      enableReinitialize
      validationSchema={validator}
      initialValues={initialValues}>
      {({
        setFieldValue,
        values,
        status,
        errors,
      }: IFormikProps<IChannelVideoForm>) => (
        <Form className='w-full h-full'>
          <TopbarTabs>
            <TopBar
              customBackItem={customBackItem}
              title={status ? tittle : undefined}
              path={backPath ?? `channel/${channelId}/channel-video`}
              topbarContent={
                <div className=' w-full flex justify-end items-center gap-2'>
                  {topbarContent}
                </div>
              }>
              <TabsNavigation
                tabs={[
                  {
                    value: 0,
                    name: 'data',
                  },
                  {
                    value: 1,
                    name: 'contracts',
                    error: errors.videoContracts,
                  },
                  {
                    value: 2,
                    name: 'player',
                  },
                ]}
                disabled={[
                  ...(disableTabs ?? []),
                  ...(channel.data?.settlementInfo?.contracts.length &&
                  channel.data?.settlementInfo.perVideoSettlement
                    ? []
                    : [1]),
                ]}
                displayMode={status?.displayMode}
              />
            </TopBar>
          </TopbarTabs>
        </Form>
      )}
    </Formik>
  );
};

ChannelVideoForm.getRouterTabs = (disabledChildren?: string[]) =>
  [
    {
      path: 'contracts',
      element: <Tab.ProductContracts propertyName='videoContracts' />,
    },
    { path: 'data', element: <ChannelVideoData /> },
    { path: 'player', element: <ChannelVideoPlayer /> },
    { path: 'contracts/history', element: <ChannelVideoContractsHistory /> },
    { path: 'contracts/future', element: <ChannelVideoContractsFuture /> },
  ].filter(children => !disabledChildren?.includes(children.path));

export default ChannelVideoForm;
